<template>
  <div class="applicant-stream-item">
    <div class="applicant-stream-header">
      <AppLabel :color="status">
        {{ sendType }}
      </AppLabel>

      <span class="applicant-stream-date">
        {{ f(stream.action_datetime) }}
      </span>
    </div>

    <div class="applicant-stream-body">{{ stream.body }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { AppLabel } from '@/client/components/_atoms'
import { getTimeFormat as f } from '@/client/utils/filters'

import { PropStreamType } from './types'

export default defineComponent({
  name: 'ApplicantStreamItem',
  components: {
    AppLabel
  },
  props: {
    stream: {
      type: Object as PropType<PropStreamType>,
      required: true
    }
  },
  setup(props) {
    const status = computed(() => {
      if (props.stream.status === 'sent') return 'success'
      if (props.stream.status === 'failed') return 'danger'
      return 'default'
    })

    const sendType = computed(() => {
      let text = ''

      if (props.stream.send_type === 'DM') text += 'DM配信'
      if (props.stream.send_type === 'mention') text += 'メンション配信'
      if (props.stream.status === 'sent') text += '成功'
      if (props.stream.status === 'failed') text += '失敗'

      return text
    })

    return {
      status,
      sendType,
      f
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.applicant-stream-item {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
}

.applicant-stream-header {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
}

.applicant-stream-date {
  color: $sub-text-color;
}

.applicant-stream-body {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
</style>
